<template>
  <teleport to="body">
    <pdl-dialog
      v-bind="modalProps"
      :visible="isVisible"
      :title="title"
      qaid="fulfillment-option-dialog"
      :close-dialog-tool-tip="$t('popup.close')"
      :z-index="16000011"
      class="pointer-events-auto"
      :show-close="true"
      :close-on-press-escape="true"
      :close-on-click-modal="true"
      @close="$emit('close')"
    >
      <template #header>
        <pdl-heading v-if="title" size="md" qaid="fulfillment-option-dialog-title">{{ title }}</pdl-heading>
      </template>
      <pdl-loading :is-loading="isLoading">
        <div class="mb-3 text-sm" qaid="fulfillment-option-dialog-content" v-html="content" />
        <image-component
          v-if="componentData.editorialImage"
          qaid="fulfillment-option-dialog-image"
          :asset-id="componentData.editorialImage"
        />
      </pdl-loading>
    </pdl-dialog>
  </teleport>
</template>

<script>
import {PdlLoading} from '@pedal/pdl-loading';
import {PdlDialog} from '@pedal/pdl-dialog';
import ImageComponent from '@/components/ImageComponent.vue';
import {PdlHeading} from '@pedal/pdl-section-header';
import {useCmsComponent} from '@/composables/cms-component.js';
import {ViewSize} from '@/constants/view-breakpoints';
import {mapGetters} from 'vuex';

export default {
  components: {
    PdlDialog,
    PdlHeading,
    ImageComponent,
    PdlLoading,
  },
  props: {
    componentId: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      componentData: null,
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters('viewSize', ['viewBreakpointMoreThan']),
    ...mapGetters('backend', ['occUrlParams']),
    title() {
      return this.componentData?.editorialTitle;
    },
    content() {
      return this.componentData?.content;
    },
    modalProps() {
      return this.viewBreakpointMoreThan(ViewSize.MEDIUM) ? {} : {fullscreen: true};
    },
  },
  created() {
    this.fetchComponentData();
  },
  methods: {
    fetchComponentData() {
      const data = useCmsComponent(this.occUrlParams.userId, this.componentId);
      this.componentData = data.componentData;
      this.isLoading = data.isLoading;
    },
  },
};
</script>
